/**
 * Webapp translations
 * > You can set a custom comments visible for translators via `crowdinContext` next to `text`
 * > cf https://store.crowdin.com/json-with-context
 * ex:
 *   Select: {
 *     text: "Please select a CAPTCHA challenge to solve:",
 *     crowdinContext: "Text visible inside crowdin for translators"
 *   },
 */
export default {
  en: {
    translation: {
      LangCode: "en",
      Select: {
        text: "Please select a CAPTCHA challenge to solve:",
      },
      Challenge1DPrompt: {
        text: "Align the two rectangles by dragging the right rectangle up/down, or by using your up/down arrow keys.",
      },
      Challenge2DPrompt: {
        text: "Complete the puzzle by dragging the puzzle piece to the correct position.",
      },
      VerificationSuccessful: {
        text: "CAPTCHA completed",
      },
      VisuallyImpairedPrompt: {
        text: "Visually impaired?",
      },
      VisuallyImpairedHelp: {
        text: 'If you are having difficulties, e.g. you are visually impaired, click on “Next”, then click on "Try a different challenge”, you will be taken to a screen with the option to solve a challenge for the visually impaired.',
      },
      Next: {
        text: "Next",
      },
      Selected: {
        text: "Selected",
      },
      SolveAChallenge: {
        text: "Solve a different challenge",
      },
      BeamAlignmentChallengeHeader: {
        text: "Align beams",
      },
      BeamAlignmentChallengeInfo: {
        text: "Align two rectangles to pass the challenge.",
      },
      PuzzleChallengeHeader: {
        text: "Complete a puzzle",
      },
      PuzzleChallengeInfo: {
        text: "Move a puzzle piece to the correct position.",
      },
      VerificationUnsuccessful: {
        text: "Sorry, you did not pass the challenge.",
      },
      Retry: {
        text: "Retry",
      },
      ResetChallenge: {
        text: "Try a different challenge",
      },
      ResetPuzzle: {
        text: "Reset puzzle piece",
      },
      SolvingChallenges: {
        text: "Verifying if you are human...",
      },
      ChallengeExpired: {
        text: "Challenge expired, please try again.",
      },
      HaveAProblem: {
        text: "Issue with ProtonCAPTCHA?",
      },
      ReportProblem: {
        text: "Report it here",
      },
    },
  },








































  de: {
    translation: {
      LangCode: "de",
      Select: {
        text: "Bitte wähle eine CAPTCHA-Heraus­for­derung zum Lösen aus:"
      },
      Challenge1DPrompt: {
        text: "Richte die beiden Rechtecke aus, indem du das rechte Rechteck nach oben/unten ziehst, oder indem du deine Pfeiltasten nach oben/unten verwendest."
      },
      Challenge2DPrompt: {
        text: "Vervollständige das Puzzle, indem du das Puzzleteil an die richtige Position ziehst."
      },
      VerificationSuccessful: {
        text: "CAPTCHA abgeschlossen"
      },
      VisuallyImpairedPrompt: {
        text: "Sehbehin­derung?"
      },
      VisuallyImpairedHelp: {
        text: "Wenn du Schwierigkeiten hast, z.B. wenn du sehbehindert bist, klicke auf „Weiter“ und dann auf „Versuche eine andere Heraus­for­derung“. Du wirst zu einem Bildschirm mit der Option weitergeleitet, eine andere Herausforderung zu lösen."
      },
      Next: {
        text: "Weiter"
      },
      Selected: {
        text: "Ausgewählt"
      },
      SolveAChallenge: {
        text: "Löse eine andere He­raus­for­de­rung"
      },
      BeamAlignmentChallengeHeader: {
        text: "Strahlen ausrichten"
      },
      BeamAlignmentChallengeInfo: {
        text: "Richte zwei Rech­tecke aus, um die He­raus­for­de­rung zu bestehen."
      },
      PuzzleChallengeHeader: {
        text: "Ein Puzzle vervoll­ständigen"
      },
      PuzzleChallengeInfo: {
        text: "Bewege ein Puzzleteil an die richtige Position."
      },
      VerificationUnsuccessful: {
        text: "Entschuldigung, du hast die Heraus­for­derung nicht bestanden."
      },
      Retry: {
        text: "Wiederholen"
      },
      ResetChallenge: {
        text: "Versuche eine andere Heraus­for­derung"
      },
      ResetPuzzle: {
        text: "Puzzleteil zurücksetzen"
      },
      SolvingChallenges: {
        text: "Überprüfung, ob du ein Mensch bist..."
      },
      ChallengeExpired: {
        text: "Die Herausforderung ist abgelaufen, bitte versuche es erneut."
      },
      HaveAProblem: {
        text: "Probleme mit ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Melde es hier"
      }
    }
  },
  fr: {
    translation: {
      LangCode: "fr",
      Select: {
        text: "Sélectionnez un test CAPTCHA à effectuer :"
      },
      Challenge1DPrompt: {
        text: "Alignez les deux rectangles en faisant glisser celui de droite vers le haut ou le bas, ou en utilisant les touches fléchées Haut/Bas de votre clavier."
      },
      Challenge2DPrompt: {
        text: "Complétez le puzzle en faisant glisser la pièce de puzzle au bon endroit."
      },
      VerificationSuccessful: {
        text: "Le test CAPTCHA est terminé."
      },
      VisuallyImpairedPrompt: {
        text: "Test CAPTCHA pour malvoyants"
      },
      VisuallyImpairedHelp: {
        text: "Vous pouvez accéder à un test adapté aux malvoyants en cliquant sur « Suivant », puis sur « Essayer un autre type de test »."
      },
      Next: {
        text: "Suivant"
      },
      Selected: {
        text: "Sélectionné"
      },
      SolveAChallenge: {
        text: "Effectuer un autre type de test"
      },
      BeamAlignmentChallengeHeader: {
        text: "Aligner les éléments"
      },
      BeamAlignmentChallengeInfo: {
        text: "Alignez deux rectangles pour réussir le test."
      },
      PuzzleChallengeHeader: {
        text: "Compléter un puzzle"
      },
      PuzzleChallengeInfo: {
        text: "Déplacez une pièce de puzzle pour la placer au bon endroit."
      },
      VerificationUnsuccessful: {
        text: "Vous n'avez malheureusement pas réussi le test."
      },
      Retry: {
        text: "Essayer à nouveau"
      },
      ResetChallenge: {
        text: "Essayer un autre type de test"
      },
      ResetPuzzle: {
        text: "Remettre la pièce de puzzle dans sa position initiale"
      },
      SolvingChallenges: {
        text: "La vérification que vous n'êtes pas un robot est en cours."
      },
      ChallengeExpired: {
        text: "Le test a expiré, essayez à nouveau."
      },
      HaveAProblem: {
        text: "Vous rencontrez un problème avec ProtonCAPTCHA ?"
      },
      ReportProblem: {
        text: "Signalez-le ici"
      }
    }
  },
  es: {
    translation: {
      LangCode: "es",
      Select: {
        text: "Selecciona el tipo de CAPTCHA que te gustaría resolver:"
      },
      Challenge1DPrompt: {
        text: "Alinee los dos rectángulos arrastrando el rectángulo derecho hacia arriba/abajo, o usando las teclas de flecha arriba/abajo."
      },
      Challenge2DPrompt: {
        text: "Completa el rompecabezas arrastrando la pieza a su posición correcta."
      },
      VerificationSuccessful: {
        text: "Se ha completado el CAPTCHA."
      },
      VisuallyImpairedPrompt: {
        text: "¿Con discapacidad visual?"
      },
      VisuallyImpairedHelp: {
        text: "Si tiene dificultades, p. tiene problemas de visión, haga clic en \"Siguiente\", luego haga clic en \"Prueba un desafío diferente\", será llevado a una pantalla con la opción de resolver un desafío diferente."
      },
      Next: {
        text: "Siguiente"
      },
      Selected: {
        text: "Seleccionado"
      },
      SolveAChallenge: {
        text: "Resuelve un desafío diferente"
      },
      BeamAlignmentChallengeHeader: {
        text: "Alinear los haces de luz"
      },
      BeamAlignmentChallengeInfo: {
        text: "Alinee dos haces de luz para completar el desafío."
      },
      PuzzleChallengeHeader: {
        text: "Completar el rompecabezas"
      },
      PuzzleChallengeInfo: {
        text: "Mueve la pieza restante para completar el rompecabezas."
      },
      VerificationUnsuccessful: {
        text: "No ha superado el desafío de verificación."
      },
      Retry: {
        text: "Reintentar"
      },
      ResetChallenge: {
        text: "Prueba un desafío diferente"
      },
      ResetPuzzle: {
        text: "Coloca la pieza del puzzle en su posición original."
      },
      SolvingChallenges: {
        text: "Verificando si eres humano..."
      },
      ChallengeExpired: {
        text: "El desafío ha expirado. Inténtalo de nuevo."
      },
      HaveAProblem: {
        text: "¿Tiene problemas con ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Reportar aquí"
      }
    }
  },
  "es-419": {
    translation: {
      LangCode: "es-419",
      Select: {
        text: "Seleccione el tipo de CAPTCHA que quiere resolver:"
      },
      Challenge1DPrompt: {
        text: "Alinee los dos rectángulos arrastrando el rectángulo derecho hacia arriba/abajo, o usando las teclas de flecha arriba/abajo."
      },
      Challenge2DPrompt: {
        text: "Complete el rompecabezas arrastrando la pieza a su posición correcta."
      },
      VerificationSuccessful: {
        text: "CAPTCHA completado"
      },
      VisuallyImpairedPrompt: {
        text: "¿Con discapacidad visual?"
      },
      VisuallyImpairedHelp: {
        text: "Si tiene dificultades, p. ej., tiene discapacidad visual, pulse en \"Siguiente\", luego pulse en \"Pruebe un desafío diferente\", y se le llevará a una pantalla con la opción de resolver un desafío diferente."
      },
      Next: {
        text: "Siguiente"
      },
      Selected: {
        text: "Seleccionado"
      },
      SolveAChallenge: {
        text: "Resolver un desafío diferente"
      },
      BeamAlignmentChallengeHeader: {
        text: "Alinear haces de luz"
      },
      BeamAlignmentChallengeInfo: {
        text: "Alinee dos haces de luz para completar el desafío."
      },
      PuzzleChallengeHeader: {
        text: "Completar un rompecabezas"
      },
      PuzzleChallengeInfo: {
        text: "Mueva la pieza restante para completar el rompecabezas."
      },
      VerificationUnsuccessful: {
        text: "No superó el desafío de verificación."
      },
      Retry: {
        text: "Reintentar"
      },
      ResetChallenge: {
        text: "Pruebe un desafío diferente"
      },
      ResetPuzzle: {
        text: "Restablecer pieza del rompecabezas"
      },
      SolvingChallenges: {
        text: "Verificando si no es un bot..."
      },
      ChallengeExpired: {
        text: "El desafío expiró, intente de nuevo."
      },
      HaveAProblem: {
        text: "¿Problemas con ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Reportar aquí"
      }
    }
  },
  it: {
    translation: {
      LangCode: "it",
      Select: {
        text: "Seleziona una sfida CAPTCHA da risolvere:"
      },
      Challenge1DPrompt: {
        text: "Allinea i due rettangoli trascinando il rettangolo di destra verso l'alto/verso il basso, o utilizzando i tasti freccia su/giù."
      },
      Challenge2DPrompt: {
        text: "Completa il puzzle trascinando il pezzo del puzzle nella posizione corretta."
      },
      VerificationSuccessful: {
        text: "CAPTCHA completato"
      },
      VisuallyImpairedPrompt: {
        text: "Sei ipovedente?"
      },
      VisuallyImpairedHelp: {
        text: "In caso di difficoltà, clicca \"Avanti\", poi clicca \"Prova una sfida diversa\", verrai indirizzato a una schermata con l'opzione per risolvere un'altra sfida adatta agli ipovedenti."
      },
      Next: {
        text: "Avanti"
      },
      Selected: {
        text: "Selezionato"
      },
      SolveAChallenge: {
        text: "Risolvi una sfida diversa"
      },
      BeamAlignmentChallengeHeader: {
        text: "Allinea i raggi"
      },
      BeamAlignmentChallengeInfo: {
        text: "Allinea due rettangoli per superare la sfida."
      },
      PuzzleChallengeHeader: {
        text: "Completa un puzzle"
      },
      PuzzleChallengeInfo: {
        text: "Sposta un pezzo del puzzle nella posizione corretta."
      },
      VerificationUnsuccessful: {
        text: "Non hai superato la sfida"
      },
      Retry: {
        text: "Riprova"
      },
      ResetChallenge: {
        text: "Prova una sfida diversa"
      },
      ResetPuzzle: {
        text: "Reimposta"
      },
      SolvingChallenges: {
        text: "Verifica umana in corso"
      },
      ChallengeExpired: {
        text: "La sfida è scaduta. Riprova."
      },
      HaveAProblem: {
        text: "Problemi con ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Segnala un problema"
      }
    }
  },
  nl: {
    translation: {
      LangCode: "nl",
      Select: {
        text: "Selecteer een CAPTCHA-uitdaging om op te lossen:"
      },
      Challenge1DPrompt: {
        text: "Lijn de twee rechthoeken uit door de rechter rechthoek omhoog/omlaag te slepen, of door uw pijltjestoetsen omhoog/omlaag te gebruiken."
      },
      Challenge2DPrompt: {
        text: "Vervolledig de puzzel door het puzzelstuk naar de juiste positie te slepen."
      },
      VerificationSuccessful: {
        text: "CAPTCHA voltooid"
      },
      VisuallyImpairedPrompt: {
        text: "Slechtziend?"
      },
      VisuallyImpairedHelp: {
        text: "Als u moeilijkheden ondervindt, bijvoorbeeld als u visueel beperkt bent, klik dan op \"Volgende\" en klik vervolgens op \"Probeer een andere uitdaging\". U wordt dan naar een scherm geleid met de optie om een uitdaging voor visueel beperkten op te lossen."
      },
      Next: {
        text: "Volgende"
      },
      Selected: {
        text: "Geselecteerd"
      },
      SolveAChallenge: {
        text: "Los een andere uitdaging op"
      },
      BeamAlignmentChallengeHeader: {
        text: "Elementen uitlijnen"
      },
      BeamAlignmentChallengeInfo: {
        text: "Lijn twee rechthoeken uit om de uitdaging te voltooien."
      },
      PuzzleChallengeHeader: {
        text: "Vervolledig een puzzel"
      },
      PuzzleChallengeInfo: {
        text: "Verplaats een puzzelstuk naar de juiste positie."
      },
      VerificationUnsuccessful: {
        text: "Sorry, u bent niet geslaagd voor de uitdaging."
      },
      Retry: {
        text: "Opnieuw proberen"
      },
      ResetChallenge: {
        text: "Probeer een andere uitdaging"
      },
      ResetPuzzle: {
        text: "Reset puzzelstuk"
      },
      SolvingChallenges: {
        text: "Verifiëren of u een mens bent..."
      },
      ChallengeExpired: {
        text: "Opgave is verlopen, probeer het opnieuw."
      },
      HaveAProblem: {
        text: "Probleem met ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Rapporteer hier"
      }
    }
  },
  pl: {
    translation: {
      LangCode: "pl",
      Select: {
        text: "Wybierz weryfikację CAPTCHA do rozwiązania:"
      },
      Challenge1DPrompt: {
        text: "Wyrównaj 2 prostokąty, przeciągając prawy prostokąt w górę i w dół. Możesz użyć do tego klawiszy strzałek."
      },
      Challenge2DPrompt: {
        text: "Ułóż puzzle, przeciągając kawałek na prawidłowe miejsce."
      },
      VerificationSuccessful: {
        text: "Weryfikacja CAPTCHA została zakończona"
      },
      VisuallyImpairedPrompt: {
        text: "Nie widzisz dobrze?"
      },
      VisuallyImpairedHelp: {
        text: "Jeśli masz problem z zadaniem, np. nie widzisz dobrze, kliknij “Dalej”, a następnie \"Rozwiąż inne zadanie”. Zostaniesz przeniesiony do zadania dla osób niedowidzących."
      },
      Next: {
        text: "Dalej"
      },
      Selected: {
        text: "Wybrano"
      },
      SolveAChallenge: {
        text: "Rozwiąż inne zadanie"
      },
      BeamAlignmentChallengeHeader: {
        text: "Wyrównaj elementy"
      },
      BeamAlignmentChallengeInfo: {
        text: "Wyrównaj 2 prostokąty, aby rozwiązać zadanie."
      },
      PuzzleChallengeHeader: {
        text: "Ułóż puzzle"
      },
      PuzzleChallengeInfo: {
        text: "Przenieś kawałek puzzla na prawidłowe miejsce."
      },
      VerificationUnsuccessful: {
        text: "Zadanie nie zostało wykonane."
      },
      Retry: {
        text: "Spróbuj ponownie"
      },
      ResetChallenge: {
        text: "Rozwiąż inne zadanie"
      },
      ResetPuzzle: {
        text: "Zresetuj kawałek puzzla"
      },
      SolvingChallenges: {
        text: "Weryfikowanie zadania..."
      },
      ChallengeExpired: {
        text: "Zadanie wygasło. Spróbuj ponownie."
      },
      HaveAProblem: {
        text: "Masz problem z ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Zgłoś problem"
      }
    }
  },
  "pt-BR": {
    translation: {
      LangCode: "pt-BR",
      Select: {
        text: "Selecione um desafio CAPTCHA para resolver:"
      },
      Challenge1DPrompt: {
        text: "Alinhe os dois retângulos arrastando o retângulo direito para cima/para baixo, ou usando as teclas de seta para cima/para baixo."
      },
      Challenge2DPrompt: {
        text: "Complete o quebra-cabeça arrastando a peça para a posição correta."
      },
      VerificationSuccessful: {
        text: "CAPTCHA completado"
      },
      VisuallyImpairedPrompt: {
        text: "Pessoa com deficiência visual?"
      },
      VisuallyImpairedHelp: {
        text: "Se você estiver tendo dificuldades, por ex. você é deficiente visual, clique em \"Avançar\", depois clique em \"Tentar um desafio diferente\", você será levado a uma tela com a opção de resolver um desafio para deficiente visual."
      },
      Next: {
        text: "Próximo"
      },
      Selected: {
        text: "Selecionado"
      },
      SolveAChallenge: {
        text: "Resolver um desafio diferente"
      },
      BeamAlignmentChallengeHeader: {
        text: "Alinhar feixes"
      },
      BeamAlignmentChallengeInfo: {
        text: "Alinhar dois retângulos para passar no desafio."
      },
      PuzzleChallengeHeader: {
        text: "Completar o quebra-cabeça"
      },
      PuzzleChallengeInfo: {
        text: "Mova a peça do quebra-cabeça para a posição correta."
      },
      VerificationUnsuccessful: {
        text: "Desculpe, você não passou no desafio."
      },
      Retry: {
        text: "Tentar novamente"
      },
      ResetChallenge: {
        text: "Resolver um desafio diferente"
      },
      ResetPuzzle: {
        text: "Restaurar peça do quebra-cabeça"
      },
      SolvingChallenges: {
        text: "Verificando se você é humano..."
      },
      ChallengeExpired: {
        text: "Desafio expirou. Tente novamente."
      },
      HaveAProblem: {
        text: "Problema com ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Reportar aqui"
      }
    }
  },
  ru: {
    translation: {
      LangCode: "ru",
      Select: {
        text: "выберите задачу CAPTCHA для решения:"
      },
      Challenge1DPrompt: {
        text: "Разместите ровно два прямоугольника, либо переместив правый из них вверх/вниз, либо при помощи клавиш со стрелками вверх/вниз."
      },
      Challenge2DPrompt: {
        text: "Сложите пазл, перетащив его фрагмент в правильное положение."
      },
      VerificationSuccessful: {
        text: "CAPTCHA завершен"
      },
      VisuallyImpairedPrompt: {
        text: "Слабое зрение?"
      },
      VisuallyImpairedHelp: {
        text: "Если у вас возникли трудности, т.е. у вас проблемы со зрением, нажмите «Следующий этап», затем нажмите «Попробуйте выполнить другую задачу», вы попадете на экран с возможностью решить другую задачу."
      },
      Next: {
        text: "Далее"
      },
      Selected: {
        text: "Выбрано"
      },
      SolveAChallenge: {
        text: "Решить другую задачу"
      },
      BeamAlignmentChallengeHeader: {
        text: "выровняйте лучи"
      },
      BeamAlignmentChallengeInfo: {
        text: "Выполните задачу, разместив ровно два прямоугольника."
      },
      PuzzleChallengeHeader: {
        text: "Решите головоломку"
      },
      PuzzleChallengeInfo: {
        text: "Переместите фрагмент пазла в правильное положение."
      },
      VerificationUnsuccessful: {
        text: "Извините, вы не прошли нашу проверку."
      },
      Retry: {
        text: "Повторить"
      },
      ResetChallenge: {
        text: "Попробуйте выполнить другую задачу"
      },
      ResetPuzzle: {
        text: "Сбросить элемент пазла"
      },
      SolvingChallenges: {
        text: "Сбросить фрагмент пазла Проверка, являетесь ли вы человеком..."
      },
      ChallengeExpired: {
        text: "Время решения задачи истекло, пожалуйста, повторите попытку."
      },
      HaveAProblem: {
        text: "Проблемы с ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Сообщить об этом здесь"
      }
    }
  },
  ko: {
    translation: {
      LangCode: "ko",
      Select: {
        text: "해결하기 위해 CAPTCHA 문제를 선택하세요:"
      },
      Challenge1DPrompt: {
        text: "오른쪽 직사각형을 위/아래로 드래그하거나 위/아래 화살표 키를 사용하여 두 직사각형을 정렬하세요."
      },
      Challenge2DPrompt: {
        text: "퍼즐 조각을 올바른 위치로 드래그하여 퍼즐을 완성하세요."
      },
      VerificationSuccessful: {
        text: "CAPTCHA 완료됨"
      },
      VisuallyImpairedPrompt: {
        text: "시각 장애가 있으신가요?"
      },
      VisuallyImpairedHelp: {
        text: "문제를 해결하는데 어려움을 겪고 계시다면, 또는 시각 장애가 있으시다면 \"다음\"을 클릭한 다음 \"다른 문제 시도\"를 클릭하세요, 그 다음 시각 장애인이 해결할 수 있는 문제가 제시됩니다."
      },
      Next: {
        text: "다음"
      },
      Selected: {
        text: "선택됨"
      },
      SolveAChallenge: {
        text: "다른 문제 해결"
      },
      BeamAlignmentChallengeHeader: {
        text: "빔을 알맞게 정렬하세요."
      },
      BeamAlignmentChallengeInfo: {
        text: "문제를 해결하기 위해 두 직사각형을 알맞게 정렬하세요."
      },
      PuzzleChallengeHeader: {
        text: "퍼즐 완성"
      },
      PuzzleChallengeInfo: {
        text: "퍼즐 조각을 알맞은 위치로 이동시키세요."
      },
      VerificationUnsuccessful: {
        text: "이 문제를 해결하지 못하셨습니다."
      },
      Retry: {
        text: "다시 시도"
      },
      ResetChallenge: {
        text: "다른 문제 시도"
      },
      ResetPuzzle: {
        text: "퍼즐 조각 재설정"
      },
      SolvingChallenges: {
        text: "사람인지 인증 중입니다..."
      },
      ChallengeExpired: {
        text: "문제가 만료되었습니다, 다시 시도해 주세요."
      },
      HaveAProblem: {
        text: "ProtonCAPTCHA에 문제가 있나요?"
      },
      ReportProblem: {
        text: "여기서 제보해 주세요."
      }
    }
  },
  ja: {
    translation: {
      LangCode: "ja",
      Select: {
        text: "CAPTCHA チャレンジを選択してください:"
      },
      Challenge1DPrompt: {
        text: "右の長方形を上下にドラッグするか、上下の矢印キーを使って2つの長方形を揃える。"
      },
      Challenge2DPrompt: {
        text: "パズルのピースを正しい位置にドラッグしてパズルを完成させよう。"
      },
      VerificationSuccessful: {
        text: "CAPTCHA完了"
      },
      VisuallyImpairedPrompt: {
        text: "視覚障害ですか?"
      },
      VisuallyImpairedHelp: {
        text: "視覚障がい者など、問題がある場合は、「次へ」をクリックし、「別の課題を試す」をクリックすると、視覚障がい者向けの課題を解くオプションが表示される画面になります。"
      },
      Next: {
        text: "次へ"
      },
      Selected: {
        text: "選択済み"
      },
      SolveAChallenge: {
        text: "別の課題を解決する"
      },
      BeamAlignmentChallengeHeader: {
        text: "ビームの位置合わせ"
      },
      BeamAlignmentChallengeInfo: {
        text: "2つの長方形を揃えて課題をクリアする。"
      },
      PuzzleChallengeHeader: {
        text: "パズルを完成させる"
      },
      PuzzleChallengeInfo: {
        text: "パズルのピースを正しい位置に移動させる。"
      },
      VerificationUnsuccessful: {
        text: "申し訳ありませんが、あなたはこのチャレンジに合格しませんでした。"
      },
      Retry: {
        text: "リトライ"
      },
      ResetChallenge: {
        text: "別の課題に挑戦する"
      },
      ResetPuzzle: {
        text: "パズルのピースをリセット"
      },
      SolvingChallenges: {
        text: "あなたが人間であるかどうかを確認しています..."
      },
      ChallengeExpired: {
        text: "チャレンジの有効期限が切れました、再度お試しください。"
      },
      HaveAProblem: {
        text: "ProtonCAPTCHA に問題がありますか?"
      },
      ReportProblem: {
        text: "報告はこちら"
      }
    }
  },
  ca: {
    translation: {
      LangCode: "ca",
      Select: {
        text: "Seleccioneu un repte CAPTCHA a resoldre:"
      },
      Challenge1DPrompt: {
        text: "Alineeu els dos rectangles arrossegant el rectangle dret cap amunt/avall, o fent servir les tecles de fletxa amunt i avall."
      },
      Challenge2DPrompt: {
        text: "Completeu el trencaclosques arrossegant la peça del trencaclosques a la posició correcta."
      },
      VerificationSuccessful: {
        text: "El CAPTCHA s'ha completat."
      },
      VisuallyImpairedPrompt: {
        text: "Teniu una discapacitat visual?"
      },
      VisuallyImpairedHelp: {
        text: "Si teniu dificultats, per exemple si teniu discapacitat visual, feu clic a \"Següent\", després feu clic a \"Provar un altre repte\", se us redirigirà a una pantalla amb l'opció de resoldre un repte per a persones amb discapacitat visual."
      },
      Next: {
        text: "Següent"
      },
      Selected: {
        text: "Seleccionat"
      },
      SolveAChallenge: {
        text: "Resol un repte diferent"
      },
      BeamAlignmentChallengeHeader: {
        text: "Alinea els elements"
      },
      BeamAlignmentChallengeInfo: {
        text: "Alineeu dos rectangles per superar el desafiament."
      },
      PuzzleChallengeHeader: {
        text: "Completa un trencaclosques"
      },
      PuzzleChallengeInfo: {
        text: "Moveu una peça del trencaclosques a la posició correcta."
      },
      VerificationUnsuccessful: {
        text: "No heu superat el repte."
      },
      Retry: {
        text: "Reintenta"
      },
      ResetChallenge: {
        text: "Prova un altre repte"
      },
      ResetPuzzle: {
        text: "Torneu la peça del trencaclosques a la seva posició original"
      },
      SolvingChallenges: {
        text: "Verificant si sou un humà..."
      },
      ChallengeExpired: {
        text: "El repte ha caducat, torneu-ho a provar."
      },
      HaveAProblem: {
        text: "Teniu problemes amb el ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Informa-ho aquí"
      }
    }
  },
  cs: {
    translation: {
      LangCode: "cs",
      Select: {
        text: "Vyberte CAPTCHA, kterou chcete vyřešit:"
      },
      Challenge1DPrompt: {
        text: "Zarovnejte dva obdélníky přetažením pravého obdélníku nahoru/dolů nebo pomocí kláves se šipkami nahoru/dolů."
      },
      Challenge2DPrompt: {
        text: "Dokončete puzzle přetažením dílku na správné místo."
      },
      VerificationSuccessful: {
        text: "CAPTCHA dokončena"
      },
      VisuallyImpairedPrompt: {
        text: "Zrakové postižení?"
      },
      VisuallyImpairedHelp: {
        text: "Pokud máte zdravotní potíže, např. jste zrakově postižení, klikněte na \"Další\" a poté na \"Zkusit jiný úkol\". Zobrazí se obrazovka s možností vyřešit úkol pro zrakově postižené."
      },
      Next: {
        text: "Další"
      },
      Selected: {
        text: "Vybráno"
      },
      SolveAChallenge: {
        text: "Vyřešit jiný úkol"
      },
      BeamAlignmentChallengeHeader: {
        text: "Vyrovnejte paprsky"
      },
      BeamAlignmentChallengeInfo: {
        text: "Zarovnáním dvou obdélníků splníte úkol."
      },
      PuzzleChallengeHeader: {
        text: "Dokončete puzzle"
      },
      PuzzleChallengeInfo: {
        text: "Přesuňte dílek puzzle na správné místo."
      },
      VerificationUnsuccessful: {
        text: "Je nám líto, úkol jste nesplnili."
      },
      Retry: {
        text: "Zkusit znovu"
      },
      ResetChallenge: {
        text: "Zkusit jiný úkol"
      },
      ResetPuzzle: {
        text: "Resetovat dílky puzzle"
      },
      SolvingChallenges: {
        text: "Ověřuji, zda jste člověk..."
      },
      ChallengeExpired: {
        text: "Úkolu vypršela platnost, zkuste to znovu."
      },
      HaveAProblem: {
        text: "Problémy s ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Nahlaste je zde"
      }
    }
  },
  da: {
    translation: {
      LangCode: "da",
      Select: {
        text: "Vælg en CAPTCHA-udfordring, du vil løse:"
      },
      Challenge1DPrompt: {
        text: "Ret de to rektangler ind efter hinanden ved at trække det højre rektangel op/ned, eller ved at bruge piletasterne op/ned."
      },
      Challenge2DPrompt: {
        text: "Færdiggør puslespillet ved at trække brikken til den rigtige position."
      },
      VerificationSuccessful: {
        text: "CAPTCHA gennemført"
      },
      VisuallyImpairedPrompt: {
        text: "Svagtseende?"
      },
      VisuallyImpairedHelp: {
        text: "Hvis du har problemer, f.eks. hvis du er synshandicappet, skal du klikke på \"Næste\" og derefter klikke på \"Prøv en anden udfordring\", så kommer du til et skærmbillede med mulighed for at løse en udfordring for synshandicappede."
      },
      Next: {
        text: "Næste"
      },
      Selected: {
        text: "Valgte"
      },
      SolveAChallenge: {
        text: "Løs en anden udfordring"
      },
      BeamAlignmentChallengeHeader: {
        text: "Ret bjælkerne efter hinanden"
      },
      BeamAlignmentChallengeInfo: {
        text: "Ret to rektangler ind efter hinanden for at bestå udfordringen."
      },
      PuzzleChallengeHeader: {
        text: "Læg et puslespil"
      },
      PuzzleChallengeInfo: {
        text: "Flyt en puslespilsbrik til den rigtige position."
      },
      VerificationUnsuccessful: {
        text: "Beklager, du klarede ikke udfordringen."
      },
      Retry: {
        text: "Forsøg igen"
      },
      ResetChallenge: {
        text: "Prøv en anden udfordring"
      },
      ResetPuzzle: {
        text: "Nulstil puslespilsbrik"
      },
      SolvingChallenges: {
        text: "Bekræftelse af, at du er et menneske..."
      },
      ChallengeExpired: {
        text: "Udfordring udløbet, prøv igen."
      },
      HaveAProblem: {
        text: "Problem med ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Rapportér det her"
      }
    }
  },
  fi: {
    translation: {
      LangCode: "fi",
      Select: {
        text: "Valitse ratkaistava CAPTCHA-haaste:"
      },
      Challenge1DPrompt: {
        text: "Kohdista kaksi suorakulmiota vetämällä oikeaa suorakulmiota ylös/alas tai käyttämällä ylös-/alas-nuolinäppäimiä."
      },
      Challenge2DPrompt: {
        text: "Ratkaise palapeli vetämällä palapelin pala oikeaan paikkaan."
      },
      VerificationSuccessful: {
        text: "CAPTCHA on suoritettu"
      },
      VisuallyImpairedPrompt: {
        text: "Oletko näkörajoitteinen?"
      },
      VisuallyImpairedHelp: {
        text: "Jos kohtaat ongelmia esimerkiksi näkörajoitteisuuden vuoksi, paina \"Seuraava\" ja sitten \"Kokeile eri haastetta\", jolloin sinulle tarjotaan myös näkörajoitteisille soveltuva haaste."
      },
      Next: {
        text: "Seuraava"
      },
      Selected: {
        text: "Valittu"
      },
      SolveAChallenge: {
        text: "Ratkaise eri haaste"
      },
      BeamAlignmentChallengeHeader: {
        text: "Kohdista palkit"
      },
      BeamAlignmentChallengeInfo: {
        text: "Kohdista kaksi suorakulmiota läpäistäksesi haasteen."
      },
      PuzzleChallengeHeader: {
        text: "Kokoa palapeli"
      },
      PuzzleChallengeInfo: {
        text: "Siirrä palapelin pala oikeaan paikkaan."
      },
      VerificationUnsuccessful: {
        text: "Valitettavasti et läpäissyt haastetta."
      },
      Retry: {
        text: "Yritä uudelleen"
      },
      ResetChallenge: {
        text: "Kokeile eri haastetta"
      },
      ResetPuzzle: {
        text: "Palauta palapelin pala"
      },
      SolvingChallenges: {
        text: "Varmistetaan että olet ihminen..."
      },
      ChallengeExpired: {
        text: "Haaste erääntyi. Yritä uudelleen."
      },
      HaveAProblem: {
        text: "Ongelmia ProtonCAPTCHA:n kanssa?"
      },
      ReportProblem: {
        text: "Ilmoita siitä täällä"
      }
    }
  },
  id: {
    translation: {
      LangCode: "id",
      Select: {
        text: "Silakan pilih tantangan CAPTCHA untuk diselesaikan:"
      },
      Challenge1DPrompt: {
        text: "Sesuaikan posisi kedua persegi panjang dengan menyeret persegi panjang kanan naik/turun, atau dengan menggunakan tombol anak panah naik/turun pada keyboard."
      },
      Challenge2DPrompt: {
        text: "Selesaikan puzzle dengan menyeret kepingan puzzle ke posisi yang benar."
      },
      VerificationSuccessful: {
        text: "CAPTCHA selesai"
      },
      VisuallyImpairedPrompt: {
        text: "Sulit melihat?"
      },
      VisuallyImpairedHelp: {
        text: "Apabila Anda mengalami kesulitan, mis. apabila Anda penyandang disabilitas visual, klik \"Berikutnya\" dan pilih \"Coba tantangan lain\". Anda akan dibawa ke layar dengan pilihan untuk menyelesaikan tantangan khusus bagi penyandang disabilitas visual."
      },
      Next: {
        text: "Berikutnya"
      },
      Selected: {
        text: "Terpilih"
      },
      SolveAChallenge: {
        text: "Selesaikan tantangan lain"
      },
      BeamAlignmentChallengeHeader: {
        text: "Sesuaikan bilah"
      },
      BeamAlignmentChallengeInfo: {
        text: "Sesuaikan posisi dua persegi panjang untuk melewati tantangan ini."
      },
      PuzzleChallengeHeader: {
        text: "Selesaikan puzzle"
      },
      PuzzleChallengeInfo: {
        text: "Pindahkan kepingan puzzle ke posisi yang benar."
      },
      VerificationUnsuccessful: {
        text: "Maaf, Anda gagal melewati tantangan ini."
      },
      Retry: {
        text: "Coba lagi"
      },
      ResetChallenge: {
        text: "Coba tantangan yang lain"
      },
      ResetPuzzle: {
        text: "Atur ulang posisi kepingan puzzle"
      },
      SolvingChallenges: {
        text: "Memverifikasi bahwa Anda manusia..."
      },
      ChallengeExpired: {
        text: "Tantangan telah kedaluwarsa, silakan coba lagi."
      },
      HaveAProblem: {
        text: "Ada isu dengan ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Laporkan di sini"
      }
    }
  },
  pt: {
    translation: {
      LangCode: "pt",
      Select: {
        text: "Selecione um desafio CAPTCHA para resolver:"
      },
      Challenge1DPrompt: {
        text: "Alinhe os dois retângulos arrastando o retângulo direito para cima/para baixo, ou utilizando as teclas de seta para cima/para baixo."
      },
      Challenge2DPrompt: {
        text: "Complete o ‘puzzle’ ao arrastar a peça do ‘puzzle’ para a posição correta."
      },
      VerificationSuccessful: {
        text: "CAPTCHA concluído"
      },
      VisuallyImpairedPrompt: {
        text: "Pessoa com deficiência visual?"
      },
      VisuallyImpairedHelp: {
        text: "Se estiver a ter dificuldades, por exemplo, tem uma deficiência visual, clique em \"Avançar\", depois clique em \"Tentar um desafio diferente\", será levado a uma janela com a opção de resolver um desafio direcionado a pessoas com uma deficiência visual."
      },
      Next: {
        text: "Seguinte"
      },
      Selected: {
        text: "Selecionado"
      },
      SolveAChallenge: {
        text: "Resolver um desafio diferente"
      },
      BeamAlignmentChallengeHeader: {
        text: "Alinhar retângulos"
      },
      BeamAlignmentChallengeInfo: {
        text: "Alinhe dois retângulos para passar o desafio."
      },
      PuzzleChallengeHeader: {
        text: "Complete o ‘puzzle’"
      },
      PuzzleChallengeInfo: {
        text: "Mova a peça do ‘puzzle’ para a posição correta."
      },
      VerificationUnsuccessful: {
        text: "Lamentamos, não passou no desafio."
      },
      Retry: {
        text: "Tentar novamente"
      },
      ResetChallenge: {
        text: "Tentar um desafio diferente"
      },
      ResetPuzzle: {
        text: "Reiniciar a peça do puzzle"
      },
      SolvingChallenges: {
        text: "A verificar se é um humano..."
      },
      ChallengeExpired: {
        text: "O desafio expirou. Tente novamente."
      },
      HaveAProblem: {
        text: "Problema com ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Reporte aqui"
      }
    }
  },
  ro: {
    translation: {
      LangCode: "ro",
      Select: {
        text: "Selectați un test CAPTCHA pentru rezolvare:"
      },
      Challenge1DPrompt: {
        text: "Aliniați cele două dreptunghiuri trăgând dreptunghiul drept în sus/jos sau utilizând tastele săgeți sus/jos."
      },
      Challenge2DPrompt: {
        text: "Completați imaginea trăgând piesa lipsă în poziția corectă."
      },
      VerificationSuccessful: {
        text: "CAPTCHA completat"
      },
      VisuallyImpairedPrompt: {
        text: "Aveți deficit vizual?"
      },
      VisuallyImpairedHelp: {
        text: "Dacă aveți dificultăți, de ex. sunteți cu deficiențe de vedere, faceți clic pe „Următorul”, apoi faceți clic pe „Încercare alt test” și veți avea opțiunea de a rezolva un test adecvat persoanelor cu deficiențe de vedere."
      },
      Next: {
        text: "Următorul"
      },
      Selected: {
        text: "Selectat"
      },
      SolveAChallenge: {
        text: "Rezolvare un test diferit"
      },
      BeamAlignmentChallengeHeader: {
        text: "Aliniați grinzile"
      },
      BeamAlignmentChallengeInfo: {
        text: "Aliniați două dreptunghiuri pentru a rezolva testul."
      },
      PuzzleChallengeHeader: {
        text: "Completați o imagine"
      },
      PuzzleChallengeInfo: {
        text: "Mutați piesa lipsă în poziția corectă."
      },
      VerificationUnsuccessful: {
        text: "Ne pare rău, nu ați rezolvat corect."
      },
      Retry: {
        text: "Reîncercare"
      },
      ResetChallenge: {
        text: "Încercare test diferit"
      },
      ResetPuzzle: {
        text: "Resetare piese imagine"
      },
      SolvingChallenges: {
        text: "Se verifică dacă sunteți o persoană..."
      },
      ChallengeExpired: {
        text: "Testul a expirat. Reîncercați."
      },
      HaveAProblem: {
        text: "Aveți probleme cu ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Raportați aici"
      }
    }
  },
  sv: {
    translation: {
      LangCode: "sv",
      Select: {
        text: "Välj en CAPTCHA-utmaning att lösa:"
      },
      Challenge1DPrompt: {
        text: "Justera de två rektanglarna genom att dra den högra rektangeln uppåt/nedåt, eller genom att använda upp/nedpilarna."
      },
      Challenge2DPrompt: {
        text: "Slutför pusslet genom att dra pusselbiten till rätt position."
      },
      VerificationSuccessful: {
        text: "CAPTCHA slutförd"
      },
      VisuallyImpairedPrompt: {
        text: "Synskadad?"
      },
      VisuallyImpairedHelp: {
        text: "Om du har svårigheter, t.ex. du är synskadad, klicka på “Nästa“. Klicka sedan på “Testa en annan utmaning“. Du kommer då till en skärm med möjlighet att lösa en utmaning för synskadade."
      },
      Next: {
        text: "Nästa"
      },
      Selected: {
        text: "Valda"
      },
      SolveAChallenge: {
        text: "Lös en annan utmaning"
      },
      BeamAlignmentChallengeHeader: {
        text: "Justera rektanglarna"
      },
      BeamAlignmentChallengeInfo: {
        text: "Justera två rektanglar för att klara utmaningen."
      },
      PuzzleChallengeHeader: {
        text: "Slutför ett pussel"
      },
      PuzzleChallengeInfo: {
        text: "Flytta en pusselbit till rätt position."
      },
      VerificationUnsuccessful: {
        text: "Du klarade inte utmaningen."
      },
      Retry: {
        text: "Försök igen"
      },
      ResetChallenge: {
        text: "Prova en annan utmaning"
      },
      ResetPuzzle: {
        text: "Återställ pusselbit"
      },
      SolvingChallenges: {
        text: "Verifierar om du är mänsklig …"
      },
      ChallengeExpired: {
        text: "Utmaning löpt ut, försök igen."
      },
      HaveAProblem: {
        text: "Problem med ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Rapportera det här"
      }
    }
  },
  tr: {
    translation: {
      LangCode: "tr",
      Select: {
        text: "Lütfen çözecek bir güvenlik kodu seçin:"
      },
      Challenge1DPrompt: {
        text: "Sağdaki dikdörtgeni yukarı/aşağı sürükleyerek ya da klavyenizdeki yukarı/aşağı tuşlarını kullanarak iki dikdörtgeni hizalayın."
      },
      Challenge2DPrompt: {
        text: "Yapboz parçasını doğru yere sürükleyerek yapbozu tamamlayın."
      },
      VerificationSuccessful: {
        text: "Güvenlik kodu tamamlandı"
      },
      VisuallyImpairedPrompt: {
        text: "Görme engelli misiniz?"
      },
      VisuallyImpairedHelp: {
        text: "Zorluk yaşıyorsanız, örneğin görme engelliyseniz, \"Sonraki\" üzerine tıklayın ve ardından \"Başka bir doğrulama deneyin\" üzerine tıklayın. Farklı bir güvenlik kodu çözme seçeneğinin olduğu bir ekrana yönlendirileceksiniz."
      },
      Next: {
        text: "Sonraki"
      },
      Selected: {
        text: "Seçilmiş"
      },
      SolveAChallenge: {
        text: "Başka bir doğrulama deneyin"
      },
      BeamAlignmentChallengeHeader: {
        text: "Işınları hizalayın"
      },
      BeamAlignmentChallengeInfo: {
        text: "Doğrulama için iki dikdörtgeni aynı hizaya getirin"
      },
      PuzzleChallengeHeader: {
        text: "Yapbozu tamamlayın"
      },
      PuzzleChallengeInfo: {
        text: "Bir yapboz parçasını doğru yere yerleştirin"
      },
      VerificationUnsuccessful: {
        text: "Özür dileriz. Güvenlik kodunu çözemediniz."
      },
      Retry: {
        text: "Yeniden deneyin"
      },
      ResetChallenge: {
        text: "Başka bir doğrulama deneyin"
      },
      ResetPuzzle: {
        text: "Yapboz parçasını ilk durumuna getir "
      },
      SolvingChallenges: {
        text: "İnsan olup olmadığınızı doğruluyoruz..."
      },
      ChallengeExpired: {
        text: "Doğrulama zaman aşımına uğradı. Lütfen yeniden deneyin."
      },
      HaveAProblem: {
        text: "ProtonCAPTCHA ile sorun mu yaşıyorsunuz?"
      },
      ReportProblem: {
        text: "Buraya bildirin"
      }
    }
  },
  vi: {
    translation: {
      LangCode: "vi",
      Select: {
        text: "Vui lòng chọn thử thách CAPTCHA để giải quyết:"
      },
      Challenge1DPrompt: {
        text: "Căn chỉnh hai hình chữ nhật bằng cách kéo hình chữ nhật bên phải lên/xuống hoặc bằng cách sử dụng phím mũi tên lên/xuống."
      },
      Challenge2DPrompt: {
        text: "Hoàn thành câu đố bằng cách kéo mảnh ghép vào đúng vị trí."
      },
      VerificationSuccessful: {
        text: "Đã hoàn thành CAPTCHA"
      },
      VisuallyImpairedPrompt: {
        text: "Bạn có vấn đề thị lực?"
      },
      VisuallyImpairedHelp: {
        text: "Nếu bạn gặp khó khăn, ví dụ như có vấn đề thị lực, hãy nhấp vào “Tiếp theo”, sau đó nhấp vào “Thử một thử thách khác”, bạn sẽ được đưa đến màn hình có tùy chọn giải quyết thử thách dành cho người có vấn đề thị lực."
      },
      Next: {
        text: "Tiếp theo"
      },
      Selected: {
        text: "Đã chọn"
      },
      SolveAChallenge: {
        text: "Giải quyết một thử thách khác"
      },
      BeamAlignmentChallengeHeader: {
        text: "Căn chỉnh các đường thẳng"
      },
      BeamAlignmentChallengeInfo: {
        text: "Căn chỉnh hai hình chữ nhật để vượt qua thử thách."
      },
      PuzzleChallengeHeader: {
        text: "Giải câu đố"
      },
      PuzzleChallengeInfo: {
        text: "Di chuyển một mảnh ghép đến đúng vị trí."
      },
      VerificationUnsuccessful: {
        text: "Rất tiếc, bạn đã không vượt qua thử thách."
      },
      Retry: {
        text: "Thử lại"
      },
      ResetChallenge: {
        text: "Thử một thử thách khác"
      },
      ResetPuzzle: {
        text: "Đặt lại mảnh ghép"
      },
      SolvingChallenges: {
        text: "Đang xác minh bạn là con người..."
      },
      ChallengeExpired: {
        text: "Thử thách đã hết hạn, vui lòng thử lại."
      },
      HaveAProblem: {
        text: "Sự cố với ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Báo cáo tại đây"
      }
    }
  },
  zh: {
    translation: {
      LangCode: "zh",
      Select: {
        text: "请选择要使用的验证方式："
      },
      Challenge1DPrompt: {
        text: "拖动或使用键盘方向键移动右侧的矩形，使两个矩形对齐。"
      },
      Challenge2DPrompt: {
        text: "拖动拼图块到正确位置，完成拼图。"
      },
      VerificationSuccessful: {
        text: "CAPTCHA 已通过"
      },
      VisuallyImpairedPrompt: {
        text: "请问是视障人士吗？"
      },
      VisuallyImpairedHelp: {
        text: "如果您有视力障碍或其他困难，请直接点击“下一步”，然后点击“更换验证方式”，届时您可以选择对视障人士更友好的验证方式。"
      },
      Next: {
        text: "下一步"
      },
      Selected: {
        text: "已选择"
      },
      SolveAChallenge: {
        text: "尝试另一种验证方式"
      },
      BeamAlignmentChallengeHeader: {
        text: "对齐光束"
      },
      BeamAlignmentChallengeInfo: {
        text: "对齐两个矩形以完成验证。"
      },
      PuzzleChallengeHeader: {
        text: "完成拼图"
      },
      PuzzleChallengeInfo: {
        text: "将拼图移动到正确位置。"
      },
      VerificationUnsuccessful: {
        text: "对不起，您没有通过验证。"
      },
      Retry: {
        text: "重试"
      },
      ResetChallenge: {
        text: "尝试另一种验证方式"
      },
      ResetPuzzle: {
        text: "重置拼图"
      },
      SolvingChallenges: {
        text: "正在验证您是否是人类..."
      },
      ChallengeExpired: {
        text: "验证超时，请重试。"
      },
      HaveAProblem: {
        text: "ProtonCAPTCHA 有问题吗？"
      },
      ReportProblem: {
        text: "点击此处反馈"
      }
    }
  },
  "zh-TW": {
    translation: {
      LangCode: "zh-TW",
      Select: {
        text: "請選取要解決的 CAPTCHA 挑戰："
      },
      Challenge1DPrompt: {
        text: "透過向上/向下拖曳右側矩形或使用向上/向下箭頭鍵來對齊兩個矩形。"
      },
      Challenge2DPrompt: {
        text: "將拼圖碎片拖曳到正確的位置完成拼圖。"
      },
      VerificationSuccessful: {
        text: "CAPTCHA完成"
      },
      VisuallyImpairedPrompt: {
        text: "視障人士？"
      },
      VisuallyImpairedHelp: {
        text: "若您遇到困難，例如若您是視障人士，請點擊「下一步」，然後點擊「嘗試其他挑戰」，您將進入包含解決供視障人士使用的挑戰的選項畫面。"
      },
      Next: {
        text: "下一個"
      },
      Selected: {
        text: "已選取"
      },
      SolveAChallenge: {
        text: "解決其他挑戰"
      },
      BeamAlignmentChallengeHeader: {
        text: "對齊光束"
      },
      BeamAlignmentChallengeInfo: {
        text: "對齊兩個矩形即可通過挑戰。"
      },
      PuzzleChallengeHeader: {
        text: "完成拼圖"
      },
      PuzzleChallengeInfo: {
        text: "移動拼圖碎片到正確的位置。"
      },
      VerificationUnsuccessful: {
        text: "抱歉，您無法通過挑戰。"
      },
      Retry: {
        text: "重試"
      },
      ResetChallenge: {
        text: "嘗試其他挑戰"
      },
      ResetPuzzle: {
        text: "重設拼圖碎片"
      },
      SolvingChallenges: {
        text: "正在驗證您是否為人類……"
      },
      ChallengeExpired: {
        text: "挑戰已逾時，請再試一次。"
      },
      HaveAProblem: {
        text: "ProtonCAPTCHA 有問題嗎？"
      },
      ReportProblem: {
        text: "在此回報"
      }
    }
  },
  th: {
    translation: {
      LangCode: "th",
      Select: {
        text: "โปรดเลือกแบบทดสอบ CAPTCHA ที่ต้องการทำ:"
      },
      Challenge1DPrompt: {
        text: "จัดสี่เหลี่ยมทั้งสองรูปให้ตรงกันโดยลากสี่เหลี่ยมด้านขวาขึ้น/ลง หรือใช้ปุ่มลูกศรขึ้น/ลง"
      },
      Challenge2DPrompt: {
        text: "ทำปริศนาให้สำเร็จโดยลากชิ้นส่วนไปยังตำแหน่งที่ถูกต้อง"
      },
      VerificationSuccessful: {
        text: "ทำ CAPTCHA เสร็จเรียบร้อย"
      },
      VisuallyImpairedPrompt: {
        text: "มีความบกพร่องทางการมองเห็น?"
      },
      VisuallyImpairedHelp: {
        text: "หากประสบปัญหา เช่น มีความบกพร่องทางการมองเห็น ให้คลิกที่ “ถัดไป” แล้วคลิกที่ \"ลองแบบทดสอบอื่น” ระบบจะพาไปยังหน้าจอที่มีตัวเลือกสำหรับผู้บกพร่องทางการมองเห็น"
      },
      Next: {
        text: "ถัดไป"
      },
      Selected: {
        text: "เลือกแล้ว"
      },
      SolveAChallenge: {
        text: "ทำแบบทดสอบอื่น"
      },
      BeamAlignmentChallengeHeader: {
        text: "จัดแนวแถบ"
      },
      BeamAlignmentChallengeInfo: {
        text: "จัดสี่เหลี่ยมสองรูปให้ตรงกันเพื่อผ่านการทดสอบ"
      },
      PuzzleChallengeHeader: {
        text: "ทำปริศนาให้สำเร็จ"
      },
      PuzzleChallengeInfo: {
        text: "เลื่อนชิ้นส่วนปริศนาไปยังตำแหน่งที่ถูกต้อง"
      },
      VerificationUnsuccessful: {
        text: "ขออภัย ไม่ผ่านการทดสอบ"
      },
      Retry: {
        text: "ลองอีกครั้ง"
      },
      ResetChallenge: {
        text: "ลองแบบทดสอบอื่น"
      },
      ResetPuzzle: {
        text: "รีเซ็ตชิ้นส่วนปริศนา"
      },
      SolvingChallenges: {
        text: "กำลังตรวจสอบว่าเป็นมนุษย์..."
      },
      ChallengeExpired: {
        text: "แบบทดสอบหมดอายุแล้ว โปรดลองอีกครั้ง"
      },
      HaveAProblem: {
        text: "มีปัญหากับ ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "รายงานที่นี่"
      }
    }
  },
  fil: {
    translation: {
      LangCode: "fil",
      Select: {
        text: "Mangyaring pumili ng CAPTCHA challenge na sasagutan:"
      },
      Challenge1DPrompt: {
        text: "Pagpantayin ang dalawang parihaba sa pamamagitan ng pag-drag sa kanang parihaba pataas/pababa o gamit ang iyong mga up/down arrow key."
      },
      Challenge2DPrompt: {
        text: "Kumpletuhin ang puzzle sa pamamagitan ng pag-drag ng puzzle piece sa tamang posisyon."
      },
      VerificationSuccessful: {
        text: "Nakumpleto na ang CAPTCHA"
      },
      VisuallyImpairedPrompt: {
        text: "May kapansanan sa paningin?"
      },
      VisuallyImpairedHelp: {
        text: "Kung nahihirapan ka, hal., may kapansanan ka sa paningin, i-click ang \"Susunod\", pagkatapos ay i-click ang \"Subukan ang ibang challenge\". Dadalhin ka sa isang screen na may opsyong sagutin ang challenge para sa mga may kapansanan sa paningin."
      },
      Next: {
        text: "Susunod"
      },
      Selected: {
        text: "Napili"
      },
      SolveAChallenge: {
        text: "Sumagot ng ibang challenge"
      },
      BeamAlignmentChallengeHeader: {
        text: "Pagpantayin ang mga beam"
      },
      BeamAlignmentChallengeInfo: {
        text: "Pagpantayin ang dalawang parihaba para maipasa ang challenge."
      },
      PuzzleChallengeHeader: {
        text: "Kumpletuhin ang puzzle"
      },
      PuzzleChallengeInfo: {
        text: "Ilipat ang puzzle piece sa tamang posisyon."
      },
      VerificationUnsuccessful: {
        text: "Paumanhin, hindi mo naipasa ang challenge."
      },
      Retry: {
        text: "Subukang muli"
      },
      ResetChallenge: {
        text: "Subukan ang ibang challenge"
      },
      ResetPuzzle: {
        text: "I-reset ang puzzle piece"
      },
      SolvingChallenges: {
        text: "Bini-verify kung tao ka..."
      },
      ChallengeExpired: {
        text: "Nag-expire na ang challenge. Pakisubukang muli."
      },
      HaveAProblem: {
        text: "May isyu sa ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "I-ulat dito"
      }
    }
  },
  hu: {
    translation: {
      LangCode: "hu",
      Select: {
        text: "Válasszon egy robot ellenőrzési kihívást:"
      },
      Challenge1DPrompt: {
        text: "Igazítsa a két téglalapot a jobb oldali téglalap fel/le húzásával, vagy a fel/le nyílbillentyűkkel."
      },
      Challenge2DPrompt: {
        text: "Fejezze be a kirakót úgy, hogy a hiányzó darabot a megfelelő helyre húzza."
      },
      VerificationSuccessful: {
        text: "Robot ellenőrzés befejezve"
      },
      VisuallyImpairedPrompt: {
        text: "Látássérült?"
      },
      VisuallyImpairedHelp: {
        text: "Ha nehézségei vannak, pl. ha látássérült, kattintson a \"Tovább\" gombra, majd kattintson a \"Másik kihívás megpróbálása\" gombra. Ekkor megjelenik egy képernyő, ahol lehetőség nyílik a látássérülteknek szóló kihívás megoldására."
      },
      Next: {
        text: "Következő"
      },
      Selected: {
        text: "Kiválasztva"
      },
      SolveAChallenge: {
        text: "Másik kihívás megoldása"
      },
      BeamAlignmentChallengeHeader: {
        text: "Téglalapok összeillesztése"
      },
      BeamAlignmentChallengeInfo: {
        text: "Téglalapokat kell egymás mellé két illeszteni, a kihívás teljesítéséhez."
      },
      PuzzleChallengeHeader: {
        text: "Egy kirakó megoldása"
      },
      PuzzleChallengeInfo: {
        text: "Egy kirakó hiányzó darabját kell a megfelelő helyre húzni."
      },
      VerificationUnsuccessful: {
        text: "Sajnáljuk, de nem sikerült megoldania a kihívást."
      },
      Retry: {
        text: "Újra"
      },
      ResetChallenge: {
        text: "Másik kihívás megpróbálása"
      },
      ResetPuzzle: {
        text: "Kirakó darab visszaállítása"
      },
      SolvingChallenges: {
        text: "Ellenőrizzük, hogy ön nem robot..."
      },
      ChallengeExpired: {
        text: "A feladat lejárt, próbálja meg újra."
      },
      HaveAProblem: {
        text: "Probléma a Proton robot ellenőrzéssel?"
      },
      ReportProblem: {
        text: "Jelentse itt"
      }
    }
  },
  lt: {
    translation: {
      LangCode: "lt",
      Select: {
        text: "Pasirinkite CAPTCHA iššūkį, kurį norite išspręsti:"
      },
      Challenge1DPrompt: {
        text: "Sulygiuokite du stačiakampius, vilkdami dešinįjį stačiakampį aukštyn / žemyn arba naudodami rodyklių aukštyn / žemyn klavišus."
      },
      Challenge2DPrompt: {
        text: "Užpildykite dėlionę vilkdami dėlionės elementą į reikiamą vietą."
      },
      VerificationSuccessful: {
        text: "CAPTCHA užbaigtas"
      },
      VisuallyImpairedPrompt: {
        text: "Turite regos sutrikimų?"
      },
      VisuallyImpairedHelp: {
        text: "Jei turite sunkumų, pvz. turite regėjimo negalią, spustelėkite „Kitas“, tada spustelėkite „Išbandyti kitą iššūkį“ ir būsite nukreipti į ekraną su galimybe išspręsti iššūkį silpnaregiams."
      },
      Next: {
        text: "Kitas"
      },
      Selected: {
        text: "Pasirinktas"
      },
      SolveAChallenge: {
        text: "Išspręsk kitokį iššūkį"
      },
      BeamAlignmentChallengeHeader: {
        text: "Sulygiuoti spindulius"
      },
      BeamAlignmentChallengeInfo: {
        text: "Sulygiuokite du stačiakampius, kad įveiktumėte iššūkį."
      },
      PuzzleChallengeHeader: {
        text: "Užpildykite dėlionę"
      },
      PuzzleChallengeInfo: {
        text: "Perkelkite dėlionės dalį į tinkamą vietą."
      },
      VerificationUnsuccessful: {
        text: "Atsiprašome, jūs neišlaikėte iššūkio."
      },
      Retry: {
        text: "Bandykite dar kartą"
      },
      ResetChallenge: {
        text: "Išbandykite kitą iššūkį"
      },
      ResetPuzzle: {
        text: "Iš naujo nustatykite dėlionės dalį"
      },
      SolvingChallenges: {
        text: "Tikrinama, ar esate žmogus..."
      },
      ChallengeExpired: {
        text: "Baigėsi iššūkis, bandykite dar kartą."
      },
      HaveAProblem: {
        text: "Problema su ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Praneškite čia"
      }
    }
  },
  no: {
    translation: {
      LangCode: "no",
      Select: {
        text: "Velg en CAPTCHA-utfordring å løse:"
      },
      Challenge1DPrompt: {
        text: "Juster de to rektanglene ved å dra høyre rektangel opp/ned, eller ved å bruke pil opp/ned."
      },
      Challenge2DPrompt: {
        text: "Fullfør puslespillet ved å dra puslespillbrikken til riktig posisjon."
      },
      VerificationSuccessful: {
        text: "CAPTCHA fullført"
      },
      VisuallyImpairedPrompt: {
        text: "Synshemmet?"
      },
      VisuallyImpairedHelp: {
        text: "Hvis du har problemer, for eksempel er du synshemmet, klikk på \"Neste\", og klikk deretter på \"Prøv en annen utfordring\", du vil bli tatt til en skjerm med muligheten til å løse en utfordring for synshemmede."
      },
      Next: {
        text: "Neste"
      },
      Selected: {
        text: "Valgt"
      },
      SolveAChallenge: {
        text: "Løs en annen utfordring"
      },
      BeamAlignmentChallengeHeader: {
        text: "Juster bjelker"
      },
      BeamAlignmentChallengeInfo: {
        text: "Juster to rektangler for å bestå denne utfordringen."
      },
      PuzzleChallengeHeader: {
        text: "Fullfør et puslespill"
      },
      PuzzleChallengeInfo: {
        text: "Dra en puslespillbrikke til korrekt posisjon."
      },
      VerificationUnsuccessful: {
        text: "Beklager, du bestod ikke utfordringen."
      },
      Retry: {
        text: "Prøv på nytt"
      },
      ResetChallenge: {
        text: "Prøv en annen utfordring"
      },
      ResetPuzzle: {
        text: "Nullstill puslespillbrikke"
      },
      SolvingChallenges: {
        text: "Bekrefter om du er menneskelig..."
      },
      ChallengeExpired: {
        text: "Utfordring utløpt, forsøk igjen."
      },
      HaveAProblem: {
        text: "Problem med Proton-Captcha?"
      },
      ReportProblem: {
        text: "Rapporter det her"
      }
    }
  },
  sk: {
    translation: {
      LangCode: "sk",
      Select: {
        text: "Vyberte úlohu CAPTCHA, ktorú chcete vyriešiť:"
      },
      Challenge1DPrompt: {
        text: "Zarovnajte oba obdĺžniky potiahnutím pravého obdĺžnika hore/dole alebo pomocou klávesov so šípkou hore/dole."
      },
      Challenge2DPrompt: {
        text: "Dokončite puzzle pretiahnutím dielika puzzle na správne miesto."
      },
      VerificationSuccessful: {
        text: "Overenie CAPTCHA bolo dokončené"
      },
      VisuallyImpairedPrompt: {
        text: "Zrakovo postihnutý?"
      },
      VisuallyImpairedHelp: {
        text: "Ak máte ťažkosti, napr. ste zrakovo postihnutý, kliknite na \"Ďalej\" a potom kliknite na \"Skúsiť inú úlohu\", zobrazí sa obrazovka s možnosťou vyriešiť úlohu pre zrakovo postihnutých."
      },
      Next: {
        text: "Ďalej"
      },
      Selected: {
        text: "Vybrané"
      },
      SolveAChallenge: {
        text: "Vyriešiť inú úlohu"
      },
      BeamAlignmentChallengeHeader: {
        text: "Zarovnajte lúče"
      },
      BeamAlignmentChallengeInfo: {
        text: "Na splnenie úlohy zarovnajte dva obdĺžniky"
      },
      PuzzleChallengeHeader: {
        text: "Dokončite puzzle"
      },
      PuzzleChallengeInfo: {
        text: "Presuňte dielik puzzle na správne miesto."
      },
      VerificationUnsuccessful: {
        text: "Je nám ľúto, ale v tejto úlohe ste neuspeli."
      },
      Retry: {
        text: "Skúsiť znova"
      },
      ResetChallenge: {
        text: "Skúsiť inú úlohu"
      },
      ResetPuzzle: {
        text: "Obnoviť kúsok puzzle"
      },
      SolvingChallenges: {
        text: "Overovanie, či ste človek..."
      },
      ChallengeExpired: {
        text: "Platnosť úlohy vypršala, skúste to znova, prosím."
      },
      HaveAProblem: {
        text: "Problém s ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Nahláste nám to"
      }
    }
  },
  sl: {
    translation: {
      LangCode: "sl",
      Select: {
        text: "Prosimo, izberite izziv CAPTCHA, ki ga želite rešiti:"
      },
      Challenge1DPrompt: {
        text: "Poravnajte oba pravokotnika tako, da povlečete desni pravokotnik gor/dol ali uporabite puščične tipke gor/dol."
      },
      Challenge2DPrompt: {
        text: "Dokončajte sestavljanko tako, da povlečete kos sestavljanke na pravilen položaj."
      },
      VerificationSuccessful: {
        text: "CAPTCHA končan"
      },
      VisuallyImpairedPrompt: {
        text: "Slabovidni?"
      },
      VisuallyImpairedHelp: {
        text: "Če imate težave, npr. ste slabovidni, kliknite »Naprej«, nato kliknite »Poskusite drugačen izziv«, preusmerjeni boste na zaslon z možnostjo reševanja izziva za slabovidne."
      },
      Next: {
        text: "Naslednji"
      },
      Selected: {
        text: "Izbrano"
      },
      SolveAChallenge: {
        text: "Rešite drugačen izziv"
      },
      BeamAlignmentChallengeHeader: {
        text: "Poravnajte žarke"
      },
      BeamAlignmentChallengeInfo: {
        text: "Poravnajte dva pravokotnika, da opravite izziv."
      },
      PuzzleChallengeHeader: {
        text: "Dokončaj sestavljanko"
      },
      PuzzleChallengeInfo: {
        text: "Premaknite kos sestavljanke na pravilen položaj."
      },
      VerificationUnsuccessful: {
        text: "Žal niste opravili izziva."
      },
      Retry: {
        text: "Poskusi znova"
      },
      ResetChallenge: {
        text: "Rešite drugačen izziv"
      },
      ResetPuzzle: {
        text: "Ponastavi kos sestavljanke"
      },
      SolvingChallenges: {
        text: "Preverjanje, ali ste človek ..."
      },
      ChallengeExpired: {
        text: "Zahteva za preverjanje pristnosti je potekla. Poskusite znova."
      },
      HaveAProblem: {
        text: "Težava s ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Sporočite tukaj"
      }
    }
  },
  el: {
    translation: {
      LangCode: "el",
      Select: {
        text: "Επιλέξτε μια πρόκληση CAPTCHA για επίλυση:"
      },
      Challenge1DPrompt: {
        text: "Ευθυγραμμίστε τα δύο ορθογώνια σύροντας το σωστό ορθογώνιο πάνω/κάτω ή χρησιμοποιώντας τα πλήκτρα επάνω/κάτω βέλους."
      },
      Challenge2DPrompt: {
        text: "Συμπληρώστε το παζλ σύροντας το κομμάτι του παζλ στη σωστή θέση."
      },
      VerificationSuccessful: {
        text: "Το CAPTCHA ολοκληρώθηκε"
      },
      VisuallyImpairedPrompt: {
        text: "Πρόβλημα όρασης;"
      },
      VisuallyImpairedHelp: {
        text: "Εάν αντιμετωπίζετε δυσκολίες, π.χ. έχετε προβλήματα όρασης, κάντε κλικ στο \"Επόμενο\" και, στη συνέχεια, κάντε κλικ στο \"Δοκιμάστε μια διαφορετική πρόκληση\", θα μεταφερθείτε σε μια οθόνη με την επιλογή επίλυσης μιας πρόκλησης για άτομα με προβλήματα όρασης."
      },
      Next: {
        text: "Επόμενο"
      },
      Selected: {
        text: "Επιλεγμένο"
      },
      SolveAChallenge: {
        text: "Λύστε μια διαφορετική πρόκληση"
      },
      BeamAlignmentChallengeHeader: {
        text: "Ευθυγράμμιση ακτίνων"
      },
      BeamAlignmentChallengeInfo: {
        text: "Ευθυγραμμίστε δύο ορθογώνια για να περάσετε την πρόκληση."
      },
      PuzzleChallengeHeader: {
        text: "Συμπληρώστε ένα παζλ"
      },
      PuzzleChallengeInfo: {
        text: "Μετακινήστε ένα κομμάτι παζλ στη σωστή θέση."
      },
      VerificationUnsuccessful: {
        text: "Λυπούμαστε, δεν περάσατε την πρόκληση."
      },
      Retry: {
        text: "Δοκιμάστε ξανά"
      },
      ResetChallenge: {
        text: "Δοκιμάστε μια διαφορετική πρόκληση"
      },
      ResetPuzzle: {
        text: "Επαναφορά κομματιού παζλ"
      },
      SolvingChallenges: {
        text: "Επαλήθευση αν είστε άνθρωπος..."
      },
      ChallengeExpired: {
        text: "Η πρόσκληση εξέπνευσε, παρακαλούμε δοκιμάστε ξανά."
      },
      HaveAProblem: {
        text: "Πρόβλημα με το ProtonCAPTCHA;"
      },
      ReportProblem: {
        text: "Αναφέρετέ το εδώ"
      }
    }
  },
  be: {
    translation: {
      LangCode: "be",
      Select: {
        text: "Выберыце CAPTCHA для вырашэння:"
      },
      Challenge1DPrompt: {
        text: "Выраўняйце два прамавугольнікі перацягваючы іх мышшу ўверх/уніз, або скарыстайцеся клавішамі са стрэлкамі на клавіятуры ўверх/уніз."
      },
      Challenge2DPrompt: {
        text: "Рашыце галаваломку, перацягваючы яе фрагменты на слушныя пазіцыі."
      },
      VerificationSuccessful: {
        text: "CAPTCHA пройдзена"
      },
      VisuallyImpairedPrompt: {
        text: "У вас парушаны зрок?"
      },
      VisuallyImpairedHelp: {
        text: "Калі ў вас праблемы (напрыклад, парушаны зрок), націсніце \"Далей\", а потым націсніце \"Іншы спосаб праверкі\". Вы будзеце перанакіраваны ў раздзел рашэння задач для людзей з парушаным зрокам."
      },
      Next: {
        text: "Далей"
      },
      Selected: {
        text: "Выбрана"
      },
      SolveAChallenge: {
        text: "Рашыць іншую задачу"
      },
      BeamAlignmentChallengeHeader: {
        text: "Выраўняйце элементы"
      },
      BeamAlignmentChallengeInfo: {
        text: "Выраўняйце два прамавугольнікі для выканання задачы."
      },
      PuzzleChallengeHeader: {
        text: "Рашыце галаваломку"
      },
      PuzzleChallengeInfo: {
        text: "Перамясціце фрагменты галаваломкі на слушныя пазіцыі."
      },
      VerificationUnsuccessful: {
        text: "Вы няправільна рашылі задачу."
      },
      Retry: {
        text: "Паўтарыць"
      },
      ResetChallenge: {
        text: "Паспрабаваць іншую задачу"
      },
      ResetPuzzle: {
        text: "Скінуць фрагменты галаваломкі"
      },
      SolvingChallenges: {
        text: "Праверка, што вы чалавек..."
      },
      ChallengeExpired: {
        text: "Час рашэння задачы пратэрмінаваны. Паспрабуйце яшчэ раз."
      },
      HaveAProblem: {
        text: "Праблемы з ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Паведаміце аб гэтым тут"
      }
    }
  },
  uk: {
    translation: {
      LangCode: "uk",
      Select: {
        text: "Оберіть завдання CAPTCHA:"
      },
      Challenge1DPrompt: {
        text: "Вирівняйте два прямокутники, перетягуючи правий прямокутник вгору/вниз, або за допомогою клавіш зі стрілками."
      },
      Challenge2DPrompt: {
        text: "Складіть головоломку, перетягнувши фрагмент у правильне положення."
      },
      VerificationSuccessful: {
        text: "CAPTCHA виконано"
      },
      VisuallyImpairedPrompt: {
        text: "У вас є порушення зору?"
      },
      VisuallyImpairedHelp: {
        text: "Якщо у вас виникли труднощі, наприклад, якщо у вас є порушення зору, натисніть “Далі” та оберіть “Спробувати інше завдання”, після чого відкриється екран вибору завдання для людей із порушенням зору."
      },
      Next: {
        text: "Далі"
      },
      Selected: {
        text: "Вибрано"
      },
      SolveAChallenge: {
        text: "Виконати інше завдання"
      },
      BeamAlignmentChallengeHeader: {
        text: "Вирівняйте елементи"
      },
      BeamAlignmentChallengeInfo: {
        text: "Щоб виконати це завдання, вирівняйте два прямокутники."
      },
      PuzzleChallengeHeader: {
        text: "Складіть головоломку"
      },
      PuzzleChallengeInfo: {
        text: "Розташуйте фрагмент у правильне положення."
      },
      VerificationUnsuccessful: {
        text: "На жаль, ви не пройшли це завдання."
      },
      Retry: {
        text: "Ще раз"
      },
      ResetChallenge: {
        text: "Спробувати інше завдання"
      },
      ResetPuzzle: {
        text: "Скинути фрагмент головоломки"
      },
      SolvingChallenges: {
        text: "Перевіряємо чи ви людина..."
      },
      ChallengeExpired: {
        text: "Час завдання минув, спробуйте знову."
      },
      HaveAProblem: {
        text: "Проблеми з ProtonCAPTCHA?"
      },
      ReportProblem: {
        text: "Повідомте про це тут"
      }
    }
  },
  ka: {
    translation: {
      LangCode: "ka",
      Select: {
        text: "აირჩიეთ გამოსაცნობი CAPTCHA:"
      },
      Challenge1DPrompt: {
        text: "გაასწორეთ ორი ოთხკუთხედი, მათი ზემოთ/ქვემოთ ან მარჯვნივ მარცხნივ გადათრევით. (ეს კლავიატურის ღილაკებითაც შეგიძლიათ, გააკეთოთ)."
      },
      Challenge2DPrompt: {
        text: "ამოხსენით ეს გამოწვევა მისი ნაწილების სწორ ადგილას გადათრევით."
      },
      VerificationSuccessful: {
        text: "CAPTCHA დასრულდა"
      },
      VisuallyImpairedPrompt: {
        text: "მხედველობადაქვეითებული ბრძანდებით?"
      },
      VisuallyImpairedHelp: {
        text: "თუ გიჭირთ ამის გაკეთება, მაგალითად, იმიტომ, რომ მხედველობასთან პრობლემები გაქვთ, დააწკაპუნეთ \"შემდეგზე\", შემდეგ კი \"სხვანაირი გამოწვევის ცდაზე\". გადაგიყვანთ ეკრანზე, სადაც შეგეძლებათ, მხედველობის პრობლემების მქონეებისთვის განკუთვნილი გამოწვევა ამოხსნათ."
      },
      Next: {
        text: "შემდეგი"
      },
      Selected: {
        text: "მონიშნულია"
      },
      SolveAChallenge: {
        text: "სხვა გამოწვევის ამოხსნა"
      },
      BeamAlignmentChallengeHeader: {
        text: "სხივების გასწორება"
      },
      BeamAlignmentChallengeInfo: {
        text: "გამოწვევის ამოსახსნელად გაასწორეთ ორი ოთხკუთხედი."
      },
      PuzzleChallengeHeader: {
        text: "გამოიცანით გამოცანა"
      },
      PuzzleChallengeInfo: {
        text: "გადაათრიეთ პაზლის ნაწილი სწორ ადგილას."
      },
      VerificationUnsuccessful: {
        text: "უკაცრავად, მაგრამ ეს გამოწვევაც ვერ გამოიცანით."
      },
      Retry: {
        text: "თავიდან"
      },
      ResetChallenge: {
        text: "სხვა გამოწვევის ცდა"
      },
      ResetPuzzle: {
        text: "პაზლის ელემენტის განულება"
      },
      SolvingChallenges: {
        text: "ვამოწმებთ, ადამიანი ბრძანდებით თუ რამე სხვა..."
      },
      ChallengeExpired: {
        text: "გამოწვევა ვადაგასულია. თავიდან სცადეთ."
      },
      HaveAProblem: {
        text: "პრობლემები ProtonCAPTCHA-სთან?"
      },
      ReportProblem: {
        text: "ამის შესახებ შეატყობინეთ აქ"
      }
    }
  },
  ar: {
    translation: {
      LangCode: "ar",
      Select: {
        text: "الرجاء اختيار تحدي CAPTCHA لحله:"
      },
      Challenge1DPrompt: {
        text: "اجعل المستطيلين الاثنين على نسق واحد عبر سحب المستطيل الأيمن إلى الأعلى/الأسفل، أو باستخدام مفاتيح الأسهم لأعلى/لأسفل."
      },
      Challenge2DPrompt: {
        text: "أكمل اللغز بسحب قطعة اللغز إلى المكان الصحيح."
      },
      VerificationSuccessful: {
        text: "اكتملت الCAPTCHA"
      },
      VisuallyImpairedPrompt: {
        text: "لديك مشكلة بالبصر؟"
      },
      VisuallyImpairedHelp: {
        text: "إذا كنت تواجه صعوبات بحل اللغز بسبب، على سبيل المثال، مشكلة بالبصر، انقر على \"التالي\"، ثم انقر على \"جرب تحدي مختلف\"، سيتم أخذك إلى شاشة مع خيار حل تحدي لضعاف البصر."
      },
      Next: {
        text: "التالي"
      },
      Selected: {
        text: "مختارة"
      },
      SolveAChallenge: {
        text: "جرب تحدي مختلف"
      },
      BeamAlignmentChallengeHeader: {
        text: "مطابقة المستطيلات"
      },
      BeamAlignmentChallengeInfo: {
        text: "اجعل مستطيلين على نسق واحد لتجاوز التحدي."
      },
      PuzzleChallengeHeader: {
        text: "أكمل لغز"
      },
      PuzzleChallengeInfo: {
        text: "انقل قطعة لغز إلى الموضع الصحيح."
      },
      VerificationUnsuccessful: {
        text: "عذراً، لم تجتز التحدي."
      },
      Retry: {
        text: "أعد المحاولة"
      },
      ResetChallenge: {
        text: "جرب تحدياً مختلفاً"
      },
      ResetPuzzle: {
        text: "إعادة قطعة اللغز إلى الوضع الابتدائي"
      },
      SolvingChallenges: {
        text: "يتم التحقق من كونك إنساناً..."
      },
      ChallengeExpired: {
        text: "انتهت مدة صلاحية التحدي، يرجى المحاولة مرة أخرى."
      },
      HaveAProblem: {
        text: "لديك مشكلة مع ProtonCAPTCHA؟"
      },
      ReportProblem: {
        text: "أبلغ عنها هنا"
      }
    }
  },
  fa: {
    translation: {
      LangCode: "fa",
      Select: {
        text: "لطفاً یک چالش CAPTCHA را برای حل انتخاب کنید"
      },
      Challenge1DPrompt: {
        text: "با کشیدن مستطیل سمت راست به بالا/پایین، یا با استفاده از کلیدهای جهت دار بالا/پایین، دو مستطیل را تراز کنید."
      },
      Challenge2DPrompt: {
        text: "با کشیدن قطعه پازل به موقعیت صحیح، پازل را کامل کنید."
      },
      VerificationSuccessful: {
        text: "CAPTCHA کامل شد"
      },
      VisuallyImpairedPrompt: {
        text: "دارای اختلال بینایی؟"
      },
      VisuallyImpairedHelp: {
        text: "اگر مشکل دارید، به عنوان مثال، دچار اختلال بینایی هستید، روی \"بعدی\" کلیک کنید، سپس روی \"یک چالش دیگر را امتحان کنید\" کلیک کنید، به صفحه ای با گزینه ای برای حل یک چالش متفاوت هدایت می شوید."
      },
      Next: {
        text: "بعدی"
      },
      Selected: {
        text: "انتخاب شده"
      },
      SolveAChallenge: {
        text: "چالش دیگری را حل کنید"
      },
      BeamAlignmentChallengeHeader: {
        text: "تراز کردن دو پرتو"
      },
      BeamAlignmentChallengeInfo: {
        text: "برای حل چالش، دو مستطیل را تراز کنید."
      },
      PuzzleChallengeHeader: {
        text: "یک پازل را کامل کنید"
      },
      PuzzleChallengeInfo: {
        text: "یک قطعه پازل را به موقعیت صحیح حرکت دهید."
      },
      VerificationUnsuccessful: {
        text: "متأسفانه شما چالش راستی آزمایی را مردود شدید"
      },
      Retry: {
        text: "تلاش مجدد"
      },
      ResetChallenge: {
        text: "یک چالش دیگر را امتحان کنید"
      },
      ResetPuzzle: {
        text: "بازنشانی قطعه پازل"
      },
      SolvingChallenges: {
        text: "در حال بررسی اینکه آیا شما انسان هستید..."
      },
      ChallengeExpired: {
        text: "چالش منقضی شد، لطفا دوباره امتحان کنید."
      },
      HaveAProblem: {
        text: "مشکلاتی با ProtonCAPTCHA دارید؟"
      },
      ReportProblem: {
        text: "اینجا گزارش کنید"
      }
    }
  }
};